import BaseInteractionService from '@configuratorware/configurator-frontendgui/App/Services/InteractionService';
import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';
import Api from '@configuratorware/configurator-frontendgui/Framework/Api';
import { METHOD_REQUEST_OFFER_FORM_SENT } from '@configuratorware/configurator-frontendgui/App/Utils/createMessageInterface';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';

export default class InteractionService extends BaseInteractionService {
  async sendReceiveOfferRequest(formData) {
    if (formData.hasError) {
      return false;
    }

    const { configurationList, userImages } = Services.store.state.app;
    const configurationCodes = configurationList.map(({ code }) => code).join(',');

    const fieldMapping = {
      email: 'emailAddress',
      name: 'name',
      company: 'company',
      phonenumber: 'phoneNumber',
      street: 'street',
      zip: 'zip',
      city: 'city',
      country: 'country',
      customerComment: 'customerComment',
    };

    const data = new FormData();
    data.append('configurationCodes', configurationCodes);
    for (const key of Object.keys(fieldMapping)) {
      data.append(fieldMapping[key], formData[key]);
    }
    for (const configurationCode of Object.keys(userImages)) {
      const file = userImages[configurationCode];
      if (file) {
        const extension = file.name.match(/\.[\w\d]{3,4}$/)?.[0];
        data.append(configurationCode, file, `${configurationCode}${extension}`);
      }
    }

    try {
      await Api.request({ url: 'receiveoffers/request', method: 'post', data: data });
      this.postMessageToContainer({
        method: METHOD_REQUEST_OFFER_FORM_SENT,
        codes: configurationCodes,
      });
    } catch (error) {
      Services.ui.reportError(t('receiveOfferForm.sentError'));

      return false;
    }

    Services.ui.reportError(t('receiveOfferForm.sentOk'));

    return true;
  }
}
